import { observable, action, computed, toJS } from 'mobx';
import { tenantsApi } from '@/services';
import { Tenant } from '@/services/types';
export class Tenants {
  @observable accessor tenants: Tenant[] | null = null;
  @observable accessor tenant: Tenant | null = null;

  @action async getTenants() {
    const response = await tenantsApi.listTenants({ body: {} });
    if (response.tenants) {
      this.setTenants(response.tenants);
    }
  }

  @action
  setTenants(tenants: Tenant[]) {
    this.tenants = tenants;
  }

  @action
  setTenant(tenant: Tenant) {
    this.tenant = tenant;
  }

  @computed
  get tenantGroups() {
    return toJS(this.tenants) || [];
  }

  @computed
  get tenantId() {
    return this.tenant?.id;
  }
}

export default new Tenants();
